/* Push/SignalR bildiriminin `type` alanını filo panelinin hash rotasına çevirir.
   Filo web'i hash routing kullanır (App.jsx resolveHashPage). Fonksiyon ASLA boş dönmez:
   bilinmeyen bir tip bildirimi tıklanamaz yapmak yerine panele indirir. */

export const FLEET_NOTIFICATION_TYPES = {
    // Dispatch krizleri — DispatchService.TryPushFleetUnassignedAsync
    UnassignedPackage: '/#deliveries',
    CourierNotFound: '/#deliveries',
    MaxReassign: '/#deliveries',
    // Gecikme hatırlatmaları — FleetDelayReminderJobService
    DelayReminder: '/#deliveries',

    // Kurye/bölge — FleetPanelService, CourierService
    CourierRegionMissing: '/#members',
    CourierEmergency: '/#members',

    // Katılma talebi — CourierFleetJoinRequestService
    FleetJoinRequest: '/#join-requests',

    // Hakediş ve fatura — FleetPaymentService, FleetInvoiceService, CourierInvoiceService
    FleetPaymentCreated: '/#payouts',
    FleetPaymentApproved: '/#payouts',
    FleetPaymentRejected: '/#payouts',
    FleetPaymentPaid: '/#payouts',
    FleetInvoiceApproved: '/#payouts',
    FleetInvoiceRejected: '/#payouts',
    CourierInvoiceUploaded: '/#payouts',

    // Maliyet — CourierFleetCostHistoryService
    FleetCostUpdated: '/#earnings',
};

export const FLEET_NOTIFICATION_FALLBACK_LINK = '/#dashboard';

/* Teslimat/dispatch olayları `delivery:<tür>` biçiminde tipe sahiptir (bkz.
   utils/deliveryNotificationText.js). Türler zamanla artıyor; her birini yukarıdaki
   sözlüğe eklemek yerine önek tek kuralla teslimatlar sayfasına indirilir. */
export const FLEET_DELIVERY_TYPE_PREFIX = 'delivery:';
export const FLEET_DELIVERY_LINK = '/#deliveries';

export function resolveFleetNotificationLink(type) {
    if (!type) return FLEET_NOTIFICATION_FALLBACK_LINK;
    if (type.startsWith(FLEET_DELIVERY_TYPE_PREFIX)) return FLEET_DELIVERY_LINK;
    return FLEET_NOTIFICATION_TYPES[type] || FLEET_NOTIFICATION_FALLBACK_LINK;
}
